import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const FeatureTrusted = () => (
  <>
    <Helmet>
      <title>Trusted & Verified — RBI Registered NBFC | Salary Uncle</title>
      <meta name="description" content="Salary Uncle is an RBI-registered NBFC. Your data is protected with bank-grade encryption and full regulatory compliance. Trust backed by law." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to Home
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            <polyline points="9 12 11 14 15 10"/>
          </svg>
        </div>
        <span className="fd-tag">FEATURE</span>
        <h1>Trusted &amp; Verified</h1>
        <p>RBI-registered NBFC with robust data protection and complete regulatory compliance — your trust is our foundation.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "RBI Registered NBFC", desc: "Salary Uncle (Reg. No. B-14.02553) — fully licensed and regulated." },
            { title: "256-bit SSL Encryption", desc: "All data transmitted on our platform is protected with bank-grade encryption." },
            { title: "No Hidden Charges", desc: "Transparent fee structure — every charge is disclosed upfront before you sign." },
            { title: "Regulatory Compliance", desc: "We strictly comply with RBI guidelines, data protection laws, and fair lending practices." },
            { title: "Verified Lender", desc: "Verified by Credit Bureaus (CIBIL) and operates under strict KYC norms." },
            { title: "50,000+ Customers Trust Us", desc: "Over 50,000 salaried professionals have trusted Salary Uncle for their financial needs." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>Why You Can Trust Us</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Registered with the Reserve Bank of India as a Non-Banking Financial Company." },
              { step: "2", text: "All customer data is encrypted and never sold to third parties." },
              { step: "3", text: "Loan terms are fully transparent — no surprises at disbursement." },
              { step: "4", text: "Dedicated grievance redressal mechanism as per RBI norms." },
              { step: "5", text: "Regular audits and compliance checks to ensure best practices." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/apply-now" className="fd-cta-btn">Apply Now</Link>
        </div>
      </div>
    </section>
  </>
);

export default FeatureTrusted;
